import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminReviewersIndex } from '@/types';
import { AddReviewerDialog } from './components/AddReviewerDialog';
import { ReviewersTable } from './components/ReviewersTable';

export default function Index({
  title,
  eventSlug,
  eventName,
  reviewers,
  availableAdmins,
}: AdminReviewersIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">
              Application Reviewers
            </h1>
            <p className="text-muted-foreground">
              Manage who can be assigned as a reviewer for {eventName}{' '}
              submissions.
            </p>
          </div>
          <AddReviewerDialog
            eventSlug={eventSlug}
            availableAdmins={availableAdmins}
          />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Reviewers ({reviewers.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <ReviewersTable eventSlug={eventSlug} reviewers={reviewers} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
